/**
 * Site-wide scroll-to-top control. Activates when #scroll-to-top is present.
 */

const SHOW_AFTER_PX = 400;

const initScrollToTop = () => {
  const button = document.getElementById('scroll-to-top');
  if (!button) {
    return;
  }

  const updateVisibility = () => {
    const shouldShow = (window.pageYOffset || document.documentElement.scrollTop) > SHOW_AFTER_PX;
    button.classList.toggle('is-visible', shouldShow);
    if (shouldShow) {
      button.removeAttribute('hidden');
    } else {
      button.setAttribute('hidden', '');
    }
  };

  button.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();
};

export default initScrollToTop;
export { initScrollToTop };
